import React from 'react';
import { Redirect, Link } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import utils from '../Utils';
import Pagination from './slider/Pagination';







import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import style from 'style/intro.css'
import hint from 'style/hint.css'

import { virtualize } from 'react-swipeable-views-utils';
import { mod } from 'react-swipeable-views-core';
import { Button } from '@material-ui/core';

// const VirtualizeSwipeableViews = virtualize(SwipeableViews);


const STEP_TEST = 'test'
const STEP_RESULT = 'result'
class Hint extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,

    }
  }






  done = () => {
    return this.props.setIntroShow(true)
  }


  render() {
    return (
      <div class="intro-root" style={{ width: '100%' }}>

        <div style={{ display: 'flex', flexDirection: "column", flexGrow: 1, alignItems: 'center' }} class='hint-container'>
          <img src="/images/malekzade.jpeg" style={{ maxWidth: '150px', maxHeight: '150px', borderRadius: '50%', objectFit: 'cover', minWidth: '50px', minHeight: '50px' }} />
          <div class="hint-title">پنل اختصاصی مشاوره با دکتر رضا ملک زاده</div>
          <div class="hint-desc">برای مشاوره با دکتر ملک زاده می توانید از قسمت زیر وارد اپ اختصاصی مشاوره با ایشان شوید</div>
          <div class='btn' onClick={this.done} >
            انجام مشاوره

          </div>
        </div>


      </div>
    )
  }

}

export default Hint